js_check_validator()
function js_check_validator(){
    document.addEventListener('DOMContentLoaded', initCheckValidator)
}

// inicializar check validador
function initCheckValidator() {
    const items = document.querySelectorAll('.js-chcek-validator')
    
    if (items != null) {
        init()
    }
    
    function init(){
        for (let i = 0; i < items.length; i++) {
            const contents = items[i].querySelectorAll('.js-chcek-validator__content.d-block')
            activeItem(contents[0], items[i].dataset.validator)
        }
    }

    function activeItem(content, validator) {
        const cards = content.querySelectorAll('.js-chcek-validator__item')
        for (let i = 0; i < cards.length; i++) {
            cards[i].classList.add(`${validator}`)
        }
    }
}
